import { useEffect, useMemo, useState } from "react";
import EventImg from "../../assets/images/event-logo-fallback.png";
import { getImageUrl } from "../../utils/appUtils";

/** Picks the media entry with the highest numeric id; falls back to first item if none have id. */
function getImageUrlFromMaxIdMedia(cardElement) {
  const media = cardElement?.media;
  if (!Array.isArray(media) || media.length === 0) return null;

  const withId = media.filter(
    (m) => m != null && m.id !== undefined && m.id !== null && m.id !== ""
  );

  const chosen =
    withId.length > 0
      ? withId.reduce((best, m) => {
          const id = Number(m.id);
          const bestId = Number(best.id);
          const n = Number.isFinite(id) ? id : -Infinity;
          const bn = Number.isFinite(bestId) ? bestId : -Infinity;
          return n > bn ? m : best;
        })
      : media[0];

  return getImageUrl(chosen);
}

export default function ImageCardDisplay({ cardElement, isCard, customClass }) {
  // State variables
  const [useFallback, setUseFallback] = useState(false);

  // Get primary URL
  const primaryUrl = useMemo(
    () => getImageUrlFromMaxIdMedia(cardElement),
    [cardElement]
  );

  // Reset fallback when primary URL changes
  useEffect(() => {
    setUseFallback(false);
  }, [primaryUrl]);

  const imageUrl = useMemo(() => {
    if (useFallback || !primaryUrl) return EventImg;
    return primaryUrl;
  }, [primaryUrl, useFallback]);

  return (
    <img
      src={imageUrl}
      alt={cardElement?.title}
      className={customClass ? customClass : isCard ? "cardImage" : "detailsImage"}
      onError={() => setUseFallback(true)}
      style={{ cursor: "pointer" }}
    />
  );
}
